export default __webpack_public_path__ + "7887d56caea0d068fdeb88e3fba54749.svg";